import PageHandlersService from '@/utils/page-handlers-service';

const pageHandlers = new PageHandlersService();

const init = () => {
    const popup = document.querySelector('.js-success-registration-popup');

    const closePopup = () => {
        popup?.classList.remove('active');
    };

    pageHandlers.set(popup?.querySelector('.js-hp-close-bg'), closePopup);

    pageHandlers.set(popup?.querySelector('.js-hp-close'), closePopup);

    const params = new URLSearchParams(window.location.search);
    const isSuccessRegistrationPopupOpened = params.get('success-registration-opened');

    if (isSuccessRegistrationPopupOpened === 'yes') {
        popup?.classList.add('active');
        params.delete('success-registration-opened', 'yes');
        history.pushState({}, '', `${window.location.href.split('?')[0]}?${params}`);

        setTimeout(closePopup, 5000);
    }
};

const destroy = () => {
    pageHandlers.clear();
};

export default { init, destroy };
